import Typography from '@/common/components/base/typography/Typography';
import { BodyWrapperCorrectiveImagesListType } from '@/modules/adjusterReportModules/Insurer-information/components/images/correctiveImages/components/bodyFetchedImages/components/bodyWrapperCorrectiveImagesList/BodyWrapperCorrectiveImagesList.type';
import { Box } from 'styled-system/jsx';

const BodyWrapperCorrectiveImagesList = ({
  headerTitle,
  children,
}: BodyWrapperCorrectiveImagesListType) => {
  return (
    <Box display={'flex'} flexDirection={'column'} gap={16}>
      <Box display={'flex'} gap={8} alignItems={'center'}>
        <Typography textStyle={'b1'} color={'purple-1'}>
          {headerTitle}
        </Typography>
        <Box
          flexGrow={1}
          height={1}
          borderStyle={'dashed'}
          border={'1px solid {colors.gray-2}'}
        ></Box>
      </Box>
      {children}
    </Box>
  );
};

export default BodyWrapperCorrectiveImagesList;
